import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import sizeof from 'object-sizeof';
// import downloadSpeedTest from '../general/downloadSpeedTest';
import { v4 as uuidv4 } from 'uuid';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    let payload, isFileUploadStream=false, fullFile, rawBase64Data;
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='',
            variableUnavailable=false,
        } = executionObject;
        const {
            companyId='', user={}
        } = parameterObject;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            variableObject[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = parsedParameters['variableObject'];
        let resolvedParams = parsedParameters['accumulator'];

        let blobUrl = resolvedParams['blobUrl'];
        if(!resolvedParams['base64'] && !blobUrl){
            variableObject[variableName] = {
                error: {
                    message: 'File base64 text or blob URL is missing.'
                }
            };
            return {
                updatedVariableObject: variableObject,
                hasError: true,
                errorPayload: 'File base64 text or blob URL is missing.',
                hasReturnStatement: false,
                returnStatement: undefined
            };
        }

        payload = {
            companyId,
            fileName : resolvedParams['fileName'] || '',
            fileKey : resolvedParams['fileKey'] || '',
            fileType : resolvedParams['fileType'] || '',
            projectId : resolvedParams['projectId'] || '',
            fileStorageServiceId : resolvedParams['fileStorageServiceId'] || '',
            fileSize : resolvedParams['base64'] ? sizeof(resolvedParams['base64']) : resolvedParams['fileSize'] || 0,
            fileOrigin : 'inhouz function',
            user,
            queryKey : uuidv4(),
            uploadId : uuidv4()
        }

        if(!payload['fileSize']){
            variableObject[variableName] = {
                error: {
                    message: 'A valid file size is required.'
                }
            };
            return {
                updatedVariableObject: variableObject,
                hasError: true,
                errorPayload: 'A valid file size is required.',
                hasReturnStatement: false,
                returnStatement: undefined
            };
        }

        if(
            !payload['fileStorageServiceId'] ||
            typeof payload['fileStorageServiceId'] !== 'string'
        ){
            variableObject[variableName] = {
                error : {
                    message : 'File storage service ID is required.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'File storage service ID is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }


        if((payload['fileSize'] < 52428800) && !blobUrl){ // 50 mb - Keep existing logic for smaller files
            let encryptedPayload = encryptDecrypt(
                JSON.stringify({
                    payload,
                    expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                }),
                true
            );

            let response = await fetch(
                `${config.devServerProxy}/api/multimedia/upload`,
                {
                    method : 'POST',
                    headers : {
                        'Accept':"application/json",
                        'Content-Type':"application/json",
                        'Cache': 'no-cache'
                    },
                    credentials : 'omit',
                    body : JSON.stringify({
                        encryptedPayload,
                        base64 : resolvedParams['base64'] // Send full Base64 for smaller files
                    })
                }
            )
            .then(resp => resp.json())
            .catch((error) => {
                return {
                    error : {
                        message : error.message
                    }
                }
            });

            variableCopy[variableName] = response;
        }else{
            if(blobUrl){
                let blobResponse = await fetch(blobUrl);
                fullFile = await blobResponse.blob();
            }else{
                rawBase64Data = resolvedParams['base64'].split('base64,')[1];
                if (!rawBase64Data) {
                    rawBase64Data = resolvedParams['base64'];
                }
                fullFile = Buffer.from(rawBase64Data, 'base64');
                rawBase64Data = null;
            }
            
            const actualTotalFileBinarySize = blobUrl ? fullFile.size : fullFile.length;
            payload['fileSize'] = actualTotalFileBinarySize;
            isFileUploadStream = true;
            // let downloadSpeed = await downloadSpeedTest();
            // console.log('downloadSpeed', downloadSpeed)
            // let chunkSize = 4;
            // if(downloadSpeed['mbps']){
            //     chunkSize = downloadSpeed['mbps'] > 95 ? 90 : (Math.round(downloadSpeed['mbps']) - 1);
            // }
            let chunkSize = 5; // 5 MB chunks
            const BINARY_CHUNK_SIZE = chunkSize * 1024 * 1024; // 5MB binary
            const totalChunks = Math.ceil(actualTotalFileBinarySize / BINARY_CHUNK_SIZE);

            const fileName = payload.fileName;
            const totalFileSize = payload.fileSize;
            let currentSessionUri = '', uploadedParts = [], currentUploadId=uuidv4();
            console.log(`[Client] Uploading file "${fileName}" (Total Binary Size: ${totalFileSize} bytes) in ${totalChunks} binary chunks...`);

            const uploadChunk = async (i) => {
                const chunkOffset = i * BINARY_CHUNK_SIZE;
                const chunkEnd = Math.min(actualTotalFileBinarySize, (i + 1) * BINARY_CHUNK_SIZE);
                let binaryChunk = fullFile.slice(chunkOffset, chunkEnd);
                let base64Chunk;
                if(blobUrl){
                    let arrayBuffer = await binaryChunk.arrayBuffer();
                    base64Chunk = Buffer.from(arrayBuffer).toString('base64');
                }else{
                    base64Chunk = binaryChunk.toString('base64');
                }
                binaryChunk = null;
                const isLastChunk = (i === totalChunks - 1);

                const uploadParams = {
                    ...payload,
                    chunkOffset,
                    totalFileSize,
                    isLastChunk,
                    isUploadStream: true,
                    blockId: i,
                    isFirstChunk: i === 0,
                    sessionUri: currentSessionUri,
                    totalBlockCount: totalChunks,
                    queryKey: uuidv4(),
                    uploadId: currentUploadId,
                    parts: isLastChunk ? uploadedParts : undefined 
                };

                let encryptedPayload = encryptDecrypt(
                    JSON.stringify({
                        payload: uploadParams,
                        expirationTimestamp: moment().add(1000, 'seconds').unix() * 1000
                    }),
                    true
                );

                let response = await fetch(
                    `${config.devServerProxy}/api/multimedia/upload`,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': "application/json",
                            'Content-Type': "application/json",
                            'Cache': 'no-cache'
                        },
                        credentials: 'omit',
                        body: JSON.stringify({
                            encryptedPayload,
                            base64: base64Chunk
                        })
                    }
                )
                .then(resp => resp.json())
                .catch((error) => {
                    console.error(`[Client] Fetch error for chunk ${i + 1}:`, error.message);
                    return { error: { message: error.message } };
                });

                base64Chunk = null;
                encryptedPayload = null;

                console.log(`[Client] Response for chunk ${i + 1}:`, response);

                if (response.error) {
                    console.error(`[Client] Server reported error for chunk ${i + 1}:`, response.error.message);
                    throw new Error(response.error.message);
                }

                if (response.sessionUri && !currentSessionUri) {
                    currentSessionUri = response.sessionUri;
                    console.log(`[Client] Received new sessionUri: ${currentSessionUri.substring(0, 30)}...`);
                }

                // ✅ ADD THIS: Collect eTags for AWS S3
                if (response.eTag) {
                    uploadedParts.push({
                        PartNumber: i + 1,
                        ETag: response.eTag
                    });
                }
                
                // ✅ ADD THIS: Store uploadId from first chunk
                if (response.uploadId && (currentUploadId !== response.uploadId)) {
                    currentUploadId = response.uploadId;
                }

                return response;
            };

            for (let i = 0; i < totalChunks; i++) {
                await uploadChunk(i);
            }

            fullFile = null; // ✅ Force cleanup of main buffer

            variableCopy[variableName] = {success : true, fileName: fileName, totalFileSize: totalFileSize};
        }

        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.error('/utils/functionParser/general/functionTypeParser/fileStorageUploadParser catch block error', e);

        fullFile = null; // ✅ Force cleanup of main buffer
        rawBase64Data = null;

        if(payload && isFileUploadStream && payload.fileKey && payload.companyId){
            console.log(`[Client] Attempting to delete incomplete file ${payload.fileName} due to upload error.`);
            let encryptedPayload = encryptDecrypt(
                JSON.stringify({
                    payload : {
                        ...payload,
                        fileKeyList : [{
                            fileKey : payload['fileKey'],
                            companyId : payload['companyId']
                        }]
                    },
                    expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                }),
                true
            );

            fetch(
                `${config.devServerProxy}/api/multimedia/deletefiles`,
                {
                    method : 'POST',
                    headers : {
                        'Accept':"application/json",
                        'Content-Type':"application/json",
                        'Cache': 'no-cache'
                    },
                    credentials : 'omit',
                    body : JSON.stringify({
                        encryptedPayload
                    })
                }
            )
            .then(resp => resp.json())
            .then(deleteResponse => {
                console.log(`[Client] Delete attempt response for incomplete file ${payload.fileName}:`, deleteResponse);
            })
            .catch((error) => {
                console.error(`[Client] Error attempting to delete incomplete file ${payload.fileName}:`, error.message);
            });
        }

        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}
